import type { ReactNode } from "react";

export function EmptyState({
  title, description, action, icon,
}: {
  title: string;
  description?: string;
  action?: ReactNode;
  icon?: ReactNode;
}) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 rounded-xl border border-dashed border-ink-600 px-6 py-14 text-center">
      {icon && <div className="text-haze-400">{icon}</div>}
      <h3 className="text-sm font-semibold text-haze-200">{title}</h3>
      {description && <p className="max-w-sm text-sm text-haze-400 leading-relaxed">{description}</p>}
      {action && <div className="mt-2">{action}</div>}
    </div>
  );
}
